export default __webpack_public_path__ + "static/media/Edit-dots.723c75a0.svg";